import React, { useContext, useState } from 'react'

// import {makeStyles} from '@material-ui/core/styles'
import { PieChart, Pie, Tooltip, Cell, ResponsiveContainer } from 'recharts'
import classnames from 'classnames'
import {DataContext} from '../../dataContext'

import Loading from '../../utilities/Loading'
import PartyCard from './partyCard'
import GainsDiv from './GainsDiv'
import Declaration from '../../utilities/Declaration'
import { Button, ButtonGroup } from '@mui/material'
import YearButtons from '../../utilities/YearButtons'
import LiveUpdates from '../../utilities/LiveUpdates'
import getColorOverride from '../../utilities/functions'
import { useParams } from 'react-router-dom'
import { createTheme, ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    globalblue: {
        main: "#0052cc"
    }, 
    globalred: {
        main: '#e41b23', 
        contrastText: '#fff'
    }
  }
});


export default function App() {

	const [hide, toggleHide] = useState('gains')
    const {data} = useContext(DataContext)
	const {results} = data
	const {prov, year}  = useParams()

	const votesRef = 0

	const chartClasses = classnames(
		'p-2 text-xs rounded-none  rounded-tl-md border-b-0', 
	)
	const gainsClasses = classnames(
		'p-2 text-xs rounded-none  rounded-tr-md border-b-0', 
	)

    const CustomTooltip = ({active, payload, label}) => {
		if (active && payload && payload.length) {
			return (
				<div className="bg-white p-2 flex flex-col justify-center items-center rounded shadow-md shadow-inherit">
					<strong className="tooltip-name">{payload[0].name}</strong>
					<span>{payload[0].value.toLocaleString('en')} votes</span>
				</div>
			)
		}
		return null
	 }

    return (
         <div id="graphWidget-main" className={'classes.main flex content-center flex-col bg-globalbg'}>
          {(data.config && results.party) ?
		  <>
		  <div className={'classes.topDiv flex justify-between items-center border-b sm:border-grey-700'}>
			<div className={'classes.declarationDiv'}>
                {results.declaration && 
                    <Declaration declaration={results.declaration} majority={data.config.majority} showLeading={false} />
                }	
            </div>	
			{data.config.currentyear && <div className={'classes.yearButtons'}>
				<YearButtons />
			</div>}
			<ThemeProvider theme={theme}>
				<ButtonGroup className={'classes.tabDiv sm:hidden self-end rounded-none border-black'} id="tabDiv">
					<Button 
						variant={hide === "gains" ? "contained" : "outlined"} color="globalred" 
						onClick={()=>toggleHide('gains')} 
						// style={{background: hide === 'gains' ? 'rgb(224 224 224)': 'white'}}
						className={chartClasses} 
						>Pop. Vote</Button>
					<Button 
					variant={hide === "chart" ? "contained" : "outlined"} color="globalred" 
						onClick={()=>toggleHide('chart')} 
						// style={{background: hide === 'chart' ? 'rgb(224 224 224)': 'white'}}
						className={gainsClasses}
						> Gains / Losses</Button>
				</ButtonGroup>
			</ThemeProvider>
		</div>
		<div className={'classes.content flex flex-1'}>
			<div className={hide === 'gains'? 'flex-1 flex-col  sm:flex' : 'flex-1 flex-col hidden sm:flex'} style={{display: hide === 'chart' ? 'none': 'initial'}} tabIndex="0" role="group" aria-labelledby='popularVoteTitle'>
				<div title="Popular Vote" className={'classes.title font-semibold text-lg'} id="popularVoteTitle">Popular vote</div>
				<div className={'classes.chartHolder flex items-center relative'} >
					<div className={'classes.partyBars w-2/3 gap-1 flex flex-col'}>
						{results.party &&
							results.party.partyResults.sort((a,b)=>{
								if (a.seats > b.seats) {
									return -1
								} else if (a.seats < b.seats) {
									return 1
								} else return 0
							}).map((party,i)=>{
							if (results.party.partyResults.length > 6) {
								if (i < 5) {
								votesRef += party.votesPercent
								return <PartyCard key={i} party={party} result={`${party.votesPercent}%`} />
							}
							else if (i === results.party.partyResults.length -1) {
								return <PartyCard key={i} party={{nameShort: 'OTH', color: '#c0c0c0'}} result={`${votesRef ? (100-votesRef).toFixed(1):0}%`} /> 
							}
							} else				
							return <PartyCard key={i} party={party} result={`${party.votesPercent}%`} />
						})
						
						}
					</div>
					<div className={'classes.chartDiv h-full w-3/5 relative'} >
						{results.party &&
						<ResponsiveContainer height={170} className={'flex justify-center'}>
							{results.party.partyResults[0].votes ?

							<PieChart  >
								<Pie
									data={results.party.partyResults}
									fill="#8884d8"
									// label={(entry)=>{return entry.name}} 
									paddingAngle={2}
									dataKey="votes"
									
								>
								{results.party.partyResults.map((entry, index) => {
										let override = getColorOverride(entry.nameShort, data.electionString)
										return <Cell key={`cell-${index}`} fill={override?override.color : entry.color} />
									}
								)}
								</Pie>
								<Tooltip content={<CustomTooltip />} />
							</PieChart>
						:
						<PieChart>
							<Pie
								data={[{name: 'No Results', value: 100}]}
								startAngle={90}
								endAngle={450}
							>
								<Cell fill="grey" />
							</Pie>
							<Tooltip position={{x:0, y:-10}} content={<div className="tooltip-wrapper">
												<strong>No Results</strong>
											</div>}/>

						</PieChart>	
						}
						</ResponsiveContainer>
						}
					</div>	
				</div>
			</div>
			<div className={'classes.border hidden sm:block mr-2 border-r border-grey-700'}/>
			<div className={hide === 'chart'? 'flex-1 flex-col flex' : 'flex-1 flex-col hidden sm:flex'} id="gainslosses" style={{display: hide === 'gains' ? 'none': 'initial'}} tabIndex="0" role="group" aria-labelledby='gainstitle'>
				<div className={'classes.title font-semibold text-lg'} id="gainstitle">Gains / Losses</div>
				<div className={'classes.chartHolder flex flex-1'}>
					<div className={'gap-1 flex flex-col w-2/5'}>
						{results.party && results.party.partyResults.sort((a,b)=>{
								if (a.seats > b.seats) {
									return -1
								} else if (a.seats < b.seats) {
									return 1
								} else return 0
							}).map((party,i)=>{
							if (results.party.partyResults.length > 6) {
								if (i < 5) {
									return <PartyCard key={i} party={party} result={`${party.seatChange}`} election={data.electionString}/>
								}
								else if (i === data.party.partyResults.length -1) {
									return <PartyCard key={i} party={{nameShort: 'OTH', color: '#c0c0c0'}} result={`${party.seatChange}`} election={data.electionString} /> 
								}	
							} else {
								return <PartyCard key={i} party={party} result={`${party.seatChange}`} election={data.electionString}/>
							}
						})}
					</div>
					<GainsDiv data={results.party} election={data.electionString}/>
				</div>
				
			</div>
			</div>
			</> 
			
			: <Loading />}
			{results.party && 
				<div >
					<LiveUpdates time={results.party.generated} />
				</div>
			}

	</div>
	)
}
